<ng-container *ngIf="appService.menuVoice?.name === Paths.DASHBOARD">
  <dx-select-box *ngIf="dashboardService.canShareToOtherUsers() && !appService.isSmallScreen()" (onItemClick)="changeImpersonatedUser($event.itemData)"
    [dataSource]="dashboardService.visibleUsers"
    [disabled]="disabled || dashboardService.dashboardEditMode"
    [displayExpr]="dashboardService.visibleUserDisplayExpr" [value]="dashboardService.impersonatedUserId"
    itemTemplate="impersonateUserList" valueExpr="id" width="33%">
    <div *dxTemplate="let user of 'impersonateUserList'" [style.padding-left]="'20px'">
      <span>{{ dashboardService.visibleUserDisplayExpr(user) }}</span>
    </div>
  </dx-select-box>
  <dx-drop-down-button *ngIf="dashboardService.canShareToOtherUsers() && appService.isSmallScreen()"
    (onItemClick)="changeImpersonatedUser($event.itemData)" [items]="dashboardService.visibleUsers"
    [disabled]="disabled || dashboardService.dashboardEditMode" [dropDownOptions]="{width: 250, wrapperAttr: {class: 'userMenuPopup'}}"
    [showArrowIcon]="false" [class.userMenuButtonActive]="dashboardService.isImpersonatingUser()" class="userMenuButton" icon="user" itemTemplate="impersonateUserMenu" keyExpr="id">
    <div *dxTemplate="let user of 'impersonateUserMenu'"
      [class.userMenuItemSelected]="user.id === dashboardService.impersonatedUserId">
      {{ dashboardService.visibleUserDisplayExpr(user) }}
    </div>
  </dx-drop-down-button>
  <dx-button *ngIf="dashboardService.isImpersonatingUser()" (onClick)="returnToOwnUser()"
    [disabled]="disabled || dashboardService.dashboardEditMode" [elementAttr]="{id: 'returnToOwnUserButton'}"
    [hint]="'BUTTONS.HINTS.RETURN_TO_ORIGINAL_USER' | translate" class="returnToOwnUserButton" icon="revert"
    stylingMode="contained" type="default">
  </dx-button>
  <dx-select-box (onItemClick)="loadSelectedDashboard($event.itemData)" [dataSource]="dashboardService.userDashboards"
    [disabled]="!dashboardService.userDashboards || dashboardService.userDashboards.length === 0 || disabled || dashboardService.dashboardEditMode"
    [displayExpr]="'name'" [value]="dashboardService.selectedDashboard" itemTemplate="dashboardList"
    [placeholder]="dashboardService.userDashboards.length === 0 ? ('DASHBOARD.NO_DASHBOARD_PLACEHOLDER' | translate) : defaultPlaceholder"
    style="width: 100%;">
    <div *dxTemplate="let dashboard of 'dashboardList'" [style.padding-left]="'20px'">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
        <span style="flex: 1 1">{{ dashboard.name }}</span>
        <div style="flex: 1 1 auto; display: flex; flex-direction: row; justify-content: flex-end;">
          <dx-button *ngIf="!dashboardService.isImpersonatingUser()" (onClick)="deleteDashboard($event, dashboard)" [class]="'smallButtonIcons'" [disabled]="disabled"
            [elementAttr]="{class:'outlinedRedButton'}" [stylingMode]="'text'"
            [title]="'BUTTONS.HINTS.DEL_DASHBOARD' | translate"
            hint="{{'BUTTONS.HINTS.DEL_DASHBOARD' | translate}}">
            <i class="vr-ic_fluent_delete_24_regular"></i>
          </dx-button>
          <dx-button (onClick)="openDuplicateDashboard($event, dashboard)" [class]="'smallButtonIcons'"
            [disabled]="disabled || dashboardService.dashboardEditMode" [stylingMode]="'text'"
            [title]="'BUTTONS.HINTS.DUPLICATE_DASHBOARD' | translate"
            hint="{{'BUTTONS.HINTS.DUPLICATE_DASHBOARD' | translate}}">
            <i class="vr-ic_fluent_copy_24_regular"></i>
          </dx-button>
        </div>
      </div>
    </div>
  </dx-select-box>
</ng-container>

<ng-container *ngIf="appService.menuVoice?.name === Paths.CHARTS">
  <dx-select-box *ngIf="dashboardService.canShareToOtherUsers() && !appService.isSmallScreen()" (onItemClick)="changeImpersonatedUser($event.itemData)"
    [dataSource]="dashboardService.visibleUsers" [disabled]="disabled"
    [displayExpr]="dashboardService.visibleUserDisplayExpr" [value]="dashboardService.impersonatedUserId"
    itemTemplate="impersonateUserList" valueExpr="id" width="33%">
    <div *dxTemplate="let user of 'impersonateUserList'" [style.padding-left]="'20px'">
      <span>{{ dashboardService.visibleUserDisplayExpr(user) }}</span>
    </div>
  </dx-select-box>
  <dx-drop-down-button *ngIf="dashboardService.canShareToOtherUsers() && appService.isSmallScreen()"
    (onItemClick)="changeImpersonatedUser($event.itemData)" [items]="dashboardService.visibleUsers"
    [disabled]="disabled" [dropDownOptions]="{width: 250, wrapperAttr: {class: 'userMenuPopup'}}"
    [showArrowIcon]="false" [class.userMenuButtonActive]="dashboardService.isImpersonatingUser()" class="userMenuButton" icon="user" itemTemplate="impersonateUserMenu" keyExpr="id">
    <div *dxTemplate="let user of 'impersonateUserMenu'"
      [class.userMenuItemSelected]="user.id === dashboardService.impersonatedUserId">
      {{ dashboardService.visibleUserDisplayExpr(user) }}
    </div>
  </dx-drop-down-button>
  <dx-button *ngIf="dashboardService.isImpersonatingUser()" (onClick)="returnToOwnUser()"
    [disabled]="disabled" [elementAttr]="{id: 'returnToOwnUserButton'}"
    [hint]="'BUTTONS.HINTS.RETURN_TO_OWN_CHARTS' | translate" class="returnToOwnUserButton" icon="revert"
    stylingMode="contained" type="default">
  </dx-button>
  <dx-select-box #umgSelectBox (onItemClick)="checkForRealReload($event.itemData)"
    [dataSource]="dashboardService.userMetricGroups"
    [disabled]="!dashboardService.userMetricGroups || dashboardService.userMetricGroups.length === 0 || disabled"
    [displayExpr]="'name'" [value]="dashboardService.selUserMetricGroup" itemTemplate="chartList" style="width: 100%;"
    [placeholder]="dashboardService.userMetricGroups.length === 0 ? ('CHART_CREATION.NO_CHART_PLACEHOLDER' | translate) : defaultPlaceholder">
    <div *dxTemplate="let chart of 'chartList'" [style.padding-left]="'20px'">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
        <span style="flex: 1 1">{{ chart.name }}</span>
        <div style="flex: 1 1 auto; display: flex; flex-direction: row; justify-content: flex-end;">
          <dx-button *ngIf="!dashboardService.isImpersonatingUser()" (onClick)="deleteMetricGroup($event, chart, umgSelectBox)" [class]="'smallButtonIcons'"
            [disabled]="disabled" [elementAttr]="{class:'outlinedRedButton'}" [stylingMode]="'text'"
            [title]="'BUTTONS.HINTS.DEL_METRIC_GROUP' | translate"
            hint="{{'BUTTONS.HINTS.DEL_METRIC_GROUP' | translate}}">
            <i class="vr-ic_fluent_delete_24_regular"></i>
          </dx-button>
          <dx-button (onClick)="openDuplicateChart($event, chart)" [class]="'smallButtonIcons'"
            [disabled]="disabled" [stylingMode]="'text'"
            [title]="'BUTTONS.HINTS.DUPLICATE_CHART' | translate"
            hint="{{'BUTTONS.HINTS.DUPLICATE_CHART' | translate}}">
            <i class="vr-ic_fluent_copy_24_regular"></i>
          </dx-button>
        </div>
      </div>
    </div>
  </dx-select-box>
</ng-container>

<app-partition-selector (selectedPartitionChange)="changePartition($event)"
  *ngIf="isPartitionSelectorShown()" [selectedPartition]="partitionSelection.selectedPartitionId"
  [disabled]="disabled" style="width: 100%;">
</app-partition-selector>

<app-duplicate-entity-popup (entityDuplicated)="reloadDashboardsAfterDuplicate()"
  [(popupVisible)]="popupVisible" [entityId]="duplicatingDashboard?.id"
  [originalName]="duplicatingDashboard?.name" subject="dashboard"></app-duplicate-entity-popup>

<app-duplicate-entity-popup (entityDuplicated)="reloadChartsAfterDuplicate()"
  [(popupVisible)]="chartPopupVisible" [entityId]="duplicatingChart?.id"
  [originalName]="duplicatingChart?.name" subject="chart"></app-duplicate-entity-popup>
